import { LayerDetailsReport } from '@app/components/Molecules/RiskSideDrawerContent/data_fetchers/layerDetailsFetcher'
import { useMemo } from 'react'
import { useLayerDetail } from './useLayerDetail'
import { useResolvedLayer } from './useResolvedLayer'

export type SelectedLayerDetail = {
  layerDetail: LayerDetailsReport[]
  type: 'Element' | 'Hazard' | 'Contextual'
  tilesetIds: string[]
  displayName: string | undefined
}

export const useSelectedLayerDetail = (id: string | undefined) => {
  const layer = useResolvedLayer(id)
  const { data: layerDetail, isLoading, isError } = useLayerDetail(id)

  const selectedLayerDetail = useMemo((): SelectedLayerDetail | null => {
    if (!layerDetail || !layer) return null
    return {
      layerDetail,
      type: layer.type,
      tilesetIds: layer.tilesetIds,
      displayName:
        layer.type === 'Hazard'
          ? (layer.hazard.hazard_name ?? layer.displayName)
          : layer.displayName,
    }
  }, [layerDetail, layer])
  return { selectedLayerDetail, isLoading, isError }
}
